import Hero from 'pages/welcome/components/Hero'

const Referral = () => <Hero />

export default Referral
